import React, {useState} from "react";
import {Button, Form, Input} from "antd";
import {stateEnum} from "@/containers/accountConsolidationRecord/util";

const formItemLayout = {
  labelCol: {span: 3},
  wrapperCol: {span: 14},
};

const Audit = ({form, data, submit, ...props}) => {
  const {getFieldDecorator, validateFields, setFields} = form

  const _submit = (pass) => {
    validateFields((err, values) => {
      if (!err) {
        if ([null, undefined].indexOf(pass) !== -1) {
          wizNotice.error('请确认审核状态');
          return;
        } else if (pass === 3 && !values?.comment) {
          setFields({comment: {errors: [{message: "审核未通过时意见不能为空"}]}})
          return;
        }

        submit && submit({...values, state: pass});
      }
    });

  }

  const {id, comment = '', state} = data || {}
  const isRead = state !== 1

  return (
    <Form {...formItemLayout}>
      {getFieldDecorator('ids', {initialValue: id && [id]})}
      {isRead ? <Form.Item label="审核结果">{stateEnum[state]}</Form.Item> : null}
      <Form.Item label="审核意见">
        {
          !isRead ? getFieldDecorator('comment', {
            initialValue: comment,
          })(<Input.TextArea placeholder='请输入审核意见' maxLength={200} autoSize={{minRows: 3, maxRows: 6}}/>) : comment
        }
      </Form.Item>
      {
        !isRead ?
          <Form.Item wrapperCol={{span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span}}>
            <Button onClick={() => _submit(2)}>通过</Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button onClick={() => _submit(3)}>不通过</Button>
          </Form.Item> : null
      }
    </Form>
  )
}

let AuditForm = Form.create()(Audit)
export {
  AuditForm,
}

